import styled from 'styled-components';

export const StyledPrescriptionVisitDataModalField = styled.div`
   min-height: 200px;
`;

StyledPrescriptionVisitDataModalField.displayName = 'StyledPrescriptionVisitDataModalField';
